import { render, staticRenderFns } from "./ChallengePupils.vue?vue&type=template&id=4a9815e3&scoped=true&"
import script from "./ChallengePupils.vue?vue&type=script&lang=js&"
export * from "./ChallengePupils.vue?vue&type=script&lang=js&"
import style0 from "./ChallengePupils.vue?vue&type=style&index=0&id=4a9815e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9815e3",
  null
  
)

export default component.exports